import { memo, useCallback } from 'react';
import { View, Pressable, StyleSheet, Image, Text } from 'react-native';
import { I18n, Navigation } from '../components';
import { COLOR, THEME, __WEB__ } from '../../constants/styles';

import { useDispatch, useSelector } from 'react-redux';

import { getCurrentEmployer, getAssociatedEmployer } from '../../selectors/employers';
import { getCurrentUsersCase } from '../../selectors/cases';
import { logoutUser } from '../auth/actions';
import { openCaseInfo } from '../cases/actions';

import { EMPLOYER_TYPE_AIRFORCE, EMPLOYER_TYPE_MED_RECRUITER } from '../../constants/employerTypes';

import { openPrivacy, openTerms, openPrivacyStatement } from '../auth/terms';

const MYPROFILE_ICON = require('../../../resources/icon-myprofile.png');
const MY_INFO_ICON = require('../../../resources/icon-health.png');
const LOGOUT_ICON = require('../../../resources/icon-logout.png');
const SETTINGS_ICON = require('../../../resources/account_menu/icon-app-settings.png');
const HELP_ICON = require('../../../resources/account_menu/icon-help.png');
const PRIVACY_ICON = require('../../../resources/account_menu/icon-privacy-policy.png');
const TERMS_ICON = require('../../../resources/account_menu/icon-terms-of-service.png');

const MenuButton = memo((props) => {
  return (
    <Pressable style={styles.button} onPress={props.onPress}>
      <Image source={props.source} style={[styles.icon, props.iconStyle]} resizeMode="contain" />
      <Text style={THEME.textRegular}>{props.label}</Text>
    </Pressable>
  );
});

export default memo(function SideNav(props) {
  const dispatch = useDispatch();
  const associatedEmployer = useSelector(getAssociatedEmployer);
  const employer = useSelector(getCurrentEmployer);
  const usersCase = useSelector(getCurrentUsersCase);

  const isAirforceStaff = employer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  const isAirforcePatient = associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  const isMedRecruiter =
    employer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER ||
    associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER;

  const isConsumer = !isAirforceStaff && !isAirforcePatient && !isMedRecruiter;
  const showEmployerHelp = !isConsumer;

  const openAccount = useCallback(() => {
    Navigation.showModal({
      screen: 'Profile',
    });
    props.onItemSelect?.();
  }, [props.onItemSelect]);
  const openMyProfile = useCallback(() => {
    dispatch(openCaseInfo(usersCase.caseId));
    Navigation.showModal({
      screen: 'CaseInfo',
      passProps: { myInfo: true },
    });
    props.onItemSelect?.();
  }, [dispatch, props.onItemSelect, usersCase?.caseId]);
  const openHelp = useCallback(() => {
    Navigation.showModal({
      screen: 'Help',
      title: I18n.ac('help.help'),
    });
    props.onItemSelect?.();
  }, [props.onItemSelect]);
  const doLogout = useCallback(() => {
    dispatch(logoutUser(true, false, true));
    props.onItemSelect?.();
  }, [dispatch, props.onItemSelect]);
  const openSettings = useCallback(() => {
    Navigation.showModal({
      screen: 'Settings',
      title: I18n.ac('settings'),
    });
    props.onItemSelect?.();
  }, [props.onItemSelect]);

  if (!!props.internal)
    return (
      <View style={{ paddingLeft: 15 }}>
        <MenuButton
          label="Account"
          source={MYPROFILE_ICON}
          onPress={openAccount}
          iconStyle={{ width: 16, height: 16, marginLeft: 2 }}
        />
        <MenuButton
          label="Logout"
          source={LOGOUT_ICON}
          onPress={doLogout}
          iconStyle={{ width: 16, height: 16, marginLeft: 2 }}
        />
      </View>
    );

  return (
    <View style={{ paddingLeft: 15 }}>
      <MenuButton
        label="Account"
        source={MYPROFILE_ICON}
        onPress={openAccount}
        iconStyle={{ width: 16, height: 16, marginLeft: 2 }}
      />

      {!!usersCase && (
        <MenuButton
          label="My Profile"
          source={MY_INFO_ICON}
          onPress={openMyProfile}
          iconStyle={{ width: 16, height: 16, marginLeft: 2 }}
        />
      )}
      {showEmployerHelp && <MenuButton label="Help" source={HELP_ICON} onPress={openHelp} />}
      <MenuButton
        label={I18n.t('settingsScreen.appSettings')}
        source={SETTINGS_ICON}
        onPress={openSettings}
      />
      <MenuButton label={I18n.t('privacyPolicy')} source={PRIVACY_ICON} onPress={openPrivacy} />
      <MenuButton label={I18n.t('termsOfUse')} source={TERMS_ICON} onPress={openTerms} />
      <MenuButton
        label={I18n.t('privacyStatement')}
        source={PRIVACY_ICON}
        onPress={openPrivacyStatement}
      />
      <MenuButton
        label="Logout"
        source={LOGOUT_ICON}
        onPress={doLogout}
        iconStyle={{ width: 16, height: 16, marginLeft: 2 }}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: __WEB__ ? 10 : 20,
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: 10,
    tintColor: COLOR.text,
  },
  label: {},
});
